import "@sidelinesports/fan-design-system/global.css";
import "@sidelinesports/fan-design-system/background.css";
import "@sidelinesports/fan-design-system/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
